export const OPERATION_DAY_MODAL = 'OPERATION_DAY'
export const CONFIRM_OPEN_CREDIT_DAY = 'CONFIRM_OPEN_CREDIT_DAY'
